export default "__VITE_ASSET__49defc2f__"